import { hideModal, showModal } from './ui';

module.exports = function handleSubmitSuccess(form, data) {
	if(form.attr('id') === 'loginCreateAccessForm') {
		$('#step1').addClass('hidden');
		$('#step2').removeClass('hidden');
		$('#create_access2_email').focus();
	} else if(form.attr('id') === 'loginCreateAccess2Form') {
		$('#step1').addClass('hidden');
		$('#step2').addClass('hidden');
		$('#step3').removeClass('hidden');
	} else if(form.attr('id') === 'reorderForm') {
		showModal(document.getElementById('reorderSuccessModal'));
		$('#reorderForm input[type="checkbox"]').prop('checked', false);
		$('#submit_reorderForm').prop('disabled', true).addClass('disabled');
	} else if(form.attr('id') === 'chainadminAddCategory') {
		$('#sortableList').append(data.html);
		form.find('input').val('');
	} else if(form.attr('id') === 'mdmAddForm') {
		$('#itemHolder').append(data.html);
		form.find('input').val('');
	} else if(form.attr('id') === 'profileContactForm') {
		var btn = $('#submit_profileContactForm');
		btn.html('<span class="fa fa-check"></span>&nbsp;<span class="title"> Gespeichert</span>');
		setTimeout(function(){
			btn.removeClass('ui-btn-primary btn-raised btn-primary')
				.addClass('ui-btn-secondary btn-default')
				.html('<span class="title"> Speichern</span>');
		},3000);
	} else if(form.attr('id') === 'chainAdminBranchForm') {
		$.slidePanel.hide();
		var tr = $('tr#' + data.id);
		if(data.enabled === true) {
			tr.find('.togglebutton input').prop('checked', true);
		} else {
			tr.find('.togglebutton input').prop('checked', false);
		}
		tr.find('td.email').text(data.email);
	} else if(form.attr('id') === 'backendChainForm') {
		$.slidePanel.hide();
	} else if(form.attr('id') === 'dl_pass_form') {
		$('#fileHolder').html(data.html);

		 $('#fsLoadWait').addClass('hidden');
	} else if(form.hasClass('slidepanel-form')) {
		$.slidePanel.hide();
		if(data.item !== undefined && data.item.id !== undefined) {
			var tr = $('tr#' + data.item.id), field;
			$.each(data.item, function(i,e){
				field = tr.find('td.data-' + i);
				if(field !== undefined) {
					field.html(e);
				}
			});
		}

	} else if(form.attr('id') === 'logistikAddressForm') {
			hideModal(document.getElementById('addressModal'));
			$('#orderShippingAddressHolder').html(data.html);
	} else if(form.data('ref') !== undefined && data.html !== undefined) {
		var search = $(form.data('ref'));
		search.prepend(data.html);
	} else {
		var preSubmit = $('#' + form.attr('id') + 'Pre'), postSubmit = $('#' + form.attr('id') + 'Post');
		if(preSubmit !== undefined && postSubmit !== undefined)  {
			preSubmit.addClass('hidden');
			postSubmit.removeClass('hidden');
		}
	}
}
